module.exports = "//public.getcloudapp.com/packs/media/images/icons-close-a8c1e41ef56ce78ef61ff60a6ad75ac5.svg";